import { render, staticRenderFns } from "./ShareFacebook.vue?vue&type=template&id=0c48a993"
import script from "./ShareFacebook.vue?vue&type=script&lang=js"
export * from "./ShareFacebook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports